import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper.ts";
import type { BalanceSheetState } from "../hooks/useBalanceSheetState.ts";

export const BalanceSheetContext = createContext<BalanceSheetState | undefined>(undefined);

const useBalanceSheetContext = (): BalanceSheetState => {
  const context = defined(
    use(BalanceSheetContext),
    "useBalanceSheetContext must be used within a BalanceSheetContext.Provider"
  );
  return context;
};

export default useBalanceSheetContext;
